export enum IconTypes{
    DONE = "done",
    PENDING = "pending"
}